export default function AppSection() {
  return (
    <section id="app" className="relative py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="relative rounded-2xl overflow-hidden bg-gradient-to-br from-background-900 to-background-800 border border-background-200/60">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-500/10 border border-accent-500/20 mb-4">
                <i className="ri-smartphone-line text-accent-400 text-xs"></i>
                <span className="text-accent-300 text-xs font-medium">随时随地 · 追剧不停</span>
              </div>
              <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50">
                手机也能高清追剧
              </h2>
              <p className="mt-3 text-sm md:text-base text-foreground-300 leading-relaxed max-w-md">
                6080新视觉影视全面适配移动端，无论您在地铁、午休还是睡前，打开手机即可流畅观看最新电视剧。高清画质自适应、智能续播、夜间模式，让碎片时间变成追剧时光。
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <div className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-background-700/50 border border-background-600/50 cursor-pointer hover:bg-background-700 transition-colors">
                  <i className="ri-android-line text-accent-400 text-lg"></i>
                  <span className="text-sm text-background-100 font-medium">Android 版</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-background-700/50 border border-background-600/50 cursor-pointer hover:bg-background-700 transition-colors">
                  <i className="ri-apple-line text-accent-400 text-lg"></i>
                  <span className="text-sm text-background-100 font-medium">iOS 版</span>
                </div>
                <div className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-background-700/50 border border-background-600/50 cursor-pointer hover:bg-background-700 transition-colors">
                  <i className="ri-computer-line text-accent-400 text-lg"></i>
                  <span className="text-sm text-background-100 font-medium">网页版</span>
                </div>
              </div>
            </div>
            <div className="flex-1 p-6 md:p-10 flex justify-center">
              <div className="relative w-56 md:w-64 aspect-[9/16] rounded-2xl overflow-hidden border-2 border-background-600/50 bg-background-800">
                <img
                  src="https://readdy.ai/api/search-image?query=Smartphone%20screen%20showing%20Chinese%20drama%20streaming%20app%20interface%20with%20dark%20theme%2C%20drama%20poster%20thumbnails%20in%20grid%20layout%2C%20warm%20golden%20accent%20colors%2C%20clean%20modern%20UI%20design%2C%20entertainment%20app%20mockup%20on%20phone%20with%20minimal%20background&width=576&height=1024&seq=app-mockup-6080&orientation=portrait"
                  alt="6080新视觉影视 手机追剧界面"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}